<template>
	<div id="asl-consent-container">
		<h2 class="standard-setting toc-heading">Terms and conditions</h2>
		<div class="toc-contents">
			<video src="/images/asl-consent.mp4" controls playsinline="true" class="toc-video"></video>
			<p>The ASL Remote uses a camera to help you control Xfinity TV services with sign language gestures. The camera may record anyone who is in its view.</p>
			<h3>By clicking "Accept Terms," you agree that:</h3>
			<ul>
				<li>You understand the ASL Remote captures video.</li>
				<li>You have permission from anyone who may appear in the video.</li>
				<li>Xfinity will process data from this remote as described in its <a href="https://www.xfinity.com/privacy/policy" target="_blank">Privacy Policy</a>.</li>
			</ul>
		</div>
		<div class="consent-buttons-outer">
			<div class="consent-buttons">
				<button class="standard-button primary" @click="acceptConsent">Accept terms</button>
				<button class="standard-button secondary" @click="rejectConsent">Decline terms</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ASLConsent',
	methods: {
		rejectConsent: function () {
			ar.removeLocal('asl-consent');
			arRouter.push('/remote');
			return;
		},
		acceptConsent: function () {
			ar.saveLocal('asl-consent', 'true');
			arRouter.push('/asl-interface');
			return;
		}
	}
};
</script>

<style lang="scss" scoped>
#asl-consent-container {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.toc-heading {
	text-align: center;
	margin-bottom: 0.5rem;
}

.toc-video {
	width: 100%;
	margin-top: 1.5rem;
	margin-bottom: 2rem;
}

.toc-contents {
	font-family: 'XfinityBrown-Regular', sans-serif;
	font-size: 1rem;
	line-height: 1.5rem;
	/* 150% */
	margin-left: 1rem;
	margin-right: 1rem;
	margin-bottom: 15rem;
	max-width: 50rem;

	& p {
		margin-bottom: 2rem;
	}

	& a {
		text-decoration: underline;
		&:focus-visible {
			@include focus-outline;
		}
	}
}

.consent-buttons-outer {
	background-color: $xfinity-grey-80;
	width: 100%;
	position: fixed;
	bottom: 0;
}

.consent-buttons {
	display: flex;
	padding: 1rem;
	flex-direction: column;
	row-gap: 0.5rem;
	margin: 1rem;

	& .standard-button {
		margin: unset;
	}
}

@include tp {
	.toc-contents {
		margin-left: 4rem;
		margin-right: 4rem;
	}

	.consent-buttons {
		column-gap: 1rem;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
	}
}

@include md {
	.toc-contents {
		margin-left: 7rem;
		margin-right: 7rem;
	}
}
</style>
